import {ScorecardRow} from "./row";
import {GirRow} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";

export function getGirRow(row: GirRow): ScorecardRow {
    function value(gir: boolean) {
        let classes = gir ? "cell-gir" : ""
        return `<div class='${classes}'></div>`
    }

    return {
        name: "G.I.R.",
        outValues: row.data.outValues.map(gir => value(gir)),
        outTotal: row.data.outTotal,
        inValues: arrayOrEmpty(row.data.inValues).map(gir => value(gir)),
        inTotal: row.data.inTotal,
        total: row.data.total,
        classes: "gir"
    };
}
